import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientLoggerService {
  private appInsights: ApplicationInsights | null = null;

  constructor(private http: HttpClient) {
    this.initializeAppInsights();
  }

  private async initializeAppInsights(): Promise<void> {
    try {
      const config: any = await firstValueFrom(this.http.get('/api/config'));
      const connectionString = config.appInsightsConnectionString;
      
      if (connectionString) {
        this.appInsights = new ApplicationInsights({
          config: {
            connectionString: connectionString,
            enableAutoRouteTracking: true
          }
        });
        this.appInsights.loadAppInsights();
        console.log('Application Insights initialized for client-side logging');
      } else {
        console.warn('Application Insights connection string not configured');
      }
    } catch (error) {
      console.error('Failed to load config for Application Insights', error);
    }
  }

  private log(level: string, message: string, properties?: any): void {
    if (this.appInsights) {
        this.appInsights.trackTrace({ message, severityLevel: this.getSeverityLevel(level), properties });
    } else {
        console.log(`[${level.toUpperCase()}]`, message, properties);
    }
  }

    private getSeverityLevel(level: string): number {
        switch (level.toLowerCase()) {
            case 'trace': return 0;
            case 'info': return 1;
            case 'warn': return 2;
            case 'error': return 3;
            case 'fatal': return 4;
            default: return 1; // Default to info
        }
    }

  info(message: string, properties?: any): void {
    this.log('info', message, properties);
  }
  

  warn(message: string, properties?: any): void {
    this.log('warn', message, properties);
  }

  error(message: string, properties?: any): void {
    this.log('error', message, properties);
  }

  debug(message: string, properties?: any): void {
    this.log('debug', message, properties);
  }

  trace(message: string, properties?: any): void {
    this.log('trace', message, properties);
  }

  fatal(message: string, properties?: any): void {
    this.log('fatal', message, properties);
  }
}